import store from '@/store'

export default class DevicesInfo {
  static getIdentifier(username, deviceId) {
    return 'device-' + username + '-' + deviceId
  }

  static devices() {
    const devicesInfo = store.getters.devicesInfo
    if (devicesInfo) {
      return devicesInfo.devices
    }
    return []
  }
}
